import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleDismissableModal from '../modals/SimpleDismissableModal';
import styles from './FreeTrialLearnMoreModal.module.scss';
import CollarImageDesktop from '../../assets/images/free_trial_collar_desktop.png';
import CollarImageMobile from '../../assets/images/free_trial_collar_mobile.png';
import { ReactComponent as CheckIcon } from '../../assets/images/icons/check.svg';
import { getDomainConfig } from '../../lib/domainConfig';

interface FreeTrialLearnMoreModalProps {
  trigger: JSX.Element;
  onStartFreeTrial?: () => void;
  onOpen?: () => void;
  shippingPrice: string;
  subscriptionPrice: string;
}

export default function FreeTrialLearnMoreModal({
  trigger,
  onStartFreeTrial,
  onOpen,
  shippingPrice,
  subscriptionPrice,
}: FreeTrialLearnMoreModalProps) {
  const { t } = useTranslation();
  const { baseDomain } = getDomainConfig();

  const benefits = [
    t('free_trial_benefit_1'),
    t('free_trial_benefit_2'),
    t('free_trial_benefit_3'),
    t('free_trial_benefit_4'),
  ];

  return (
    <SimpleDismissableModal trigger={trigger} onOpen={onOpen}>
      {(close) => (
        <div className={styles.container}>
          <img src={CollarImageDesktop} alt="" className={styles.imageDesktop} />
          <img src={CollarImageMobile} alt="" className={styles.imageMobile} />
          <div className={styles.title}>{t('free_trial_modal_title')}</div>
          <p className={styles.subtitle}>{t('free_trial_modal_subtitle')}</p>
          <ul className={styles.benefits}>
            {benefits.map((benefit, index) => (
              <li key={index} className={styles.benefitItem}>
                <CheckIcon className={styles.checkIcon} />
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
          <p className={styles.terms}>{t('free_trial_modal_terms', { shippingPrice, subscriptionPrice })}</p>
          <p className={styles.terms}>{t('free_trial_modal_auto_continue', { subscriptionPrice })}</p>
          <p className={styles.termsLinkContainer}>
            {t('fis')}{' '}
            <a
              href={`https://${baseDomain}/tos`}
              className={styles.termsLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('terms_of_service')}
            </a>{' '}
            <span className={styles.apply}>{t('apply_see_for_additional_details')}</span>
          </p>
          {onStartFreeTrial && (
            <button
              className={styles.ctaButton}
              onClick={() => {
                onStartFreeTrial();
                close();
              }}
            >
              {t('start_free_trial')}
            </button>
          )}
        </div>
      )}
    </SimpleDismissableModal>
  );
}
